import Link from "next/link";

import { useTranslation } from "@flare/i18n";
import { Icon, Text } from "@flare/ui";

import { PERSONAL_INFO_URL, PRE_CLIENT_PATH } from "../pre-client.consts";

export function MarbleHomeButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();

  return (
    <Text
      asChild
      onClick={onClick}
      className="flex w-full cursor-pointer items-center justify-start gap-sp-2 px-sp-4 py-sp-3 transition-colors duration-150 hover:bg-(--color-secondary-alpha-light)"
    >
      <Link href={PRE_CLIENT_PATH}>
        <Icon name="house" />
        {t("GO_TO_YOUR_MARBLE_HOME")}
      </Link>
    </Text>
  );
}

export function PersonalInfoButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();

  return (
    <Text
      onClick={onClick}
      className="flex w-full cursor-pointer items-center justify-start gap-sp-2 px-sp-4 py-sp-3 transition-colors duration-150 hover:bg-(--color-secondary-alpha-light)"
      asChild
    >
      <Link href={PERSONAL_INFO_URL}>
        <Icon name="user" />
        {t("PERSONAL_INFO")}
      </Link>
    </Text>
  );
}

export function SignoutButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();

  return (
    // TODO: Remove when dropdown and drawer from DS are ready
    <button
      className="flex w-full cursor-pointer items-center justify-start gap-sp-2 px-sp-4 py-sp-3 transition-colors duration-150 hover:bg-(--color-secondary-alpha-light)"
      onClick={onClick}
    >
      <Icon name="log-out" />
      <Text variant="body1">{t("SIGN_OUT")}</Text>
    </button>
  );
}
